module.exports = __webpack_public_path__ + "static/media/Carousels-Wedding-Mobile.f15a81db.webp";